import '../assets/js/pure-swipe.min';

class ScrollLoad {
  constructor (panel, tag, cbk, ctx) {
    this.panel = panel || window;
    this.tag = tag;
    this.cbk = cbk;
    this.ctx = ctx || window;
    this.init();
  }
  init () {
    var self = this;

    this.panel.addEventListener('swiped-up', function (e) {
      if (!self.tag) {
        return false;
      }
      if (e.type === 'swiped-up') {
        if (self.tag.getBoundingClientRect().top <= document.body.clientHeight) {
          self.cbk.call(self.ctx);
        }
      }
    });
  }
};

export default{
  init (panel, tag, cbk, ctx) {
    var s = new ScrollLoad(panel, tag, cbk, ctx);

    return s;
  }
};



// WEBPACK FOOTER //
// ./src/components/scrollLoad.js